import React from 'react';

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  typography: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: '700',
    paddingTop: '15px',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '25px',
      fontSize: '30px',
    },
  },
  divider: {
    // Theme Color, or use css color in quote
    height: '5px',
    background: '#FFAA05',
  },
  view: {
    // Theme Color, or use css color in quote
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      height: 'auto',
    },
  },
  text: {
    padding: '0px',
    fontFamily: 'Barlow',
    fontSize: '17px',
    lineHeight: '30px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '24px',
      lineHeight: '28px',
      padding: '0px',
    },
  },
  special: {
    color: 'red',
  },
}));

export default function Inscriptions() {
  const classes = useStyles();
  const scientific = [
    'Las ponencias se realizaran de manera virtual a través de la plataforma Zoom.',
    'El certificado de participación de los asistentes se entregará de manera gratuita y solo a los asistentes que tengan un mínimo de 60% ponencias asistidas. Los datos del certificado se realizarán con los datos registrados en el formulario de inscripción. ',
    'Las solicitudes de registro serán recepcionadas desde el 09 de Enero hasta el 08 de Febrero.',
  ];
  return (
    <div className={classes.view}>
      <Typography variant="h1" className={classes.typography}>
        Inscripciones

      </Typography>
      <Divider classes={{ root: classes.divider }} />
      <Typography variant="h6" className={classes.text}>
        <ul style={{ marginLeft: '0px' }}>
          {
            scientific.map((scy) => (
              <li style={{ marginLeft: '0px', paddingTop: '10px' }}>
                {scy}
              </li>
            ))
              }
          <li style={{ marginLeft: '0px', paddingTop: '10px' }}>
            Enviar su solicitud de registo a través del siguiente enlace:
            {' '}
            {/* <span className={classes.special}>Próximamente</span> */}
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeaMv7E_szinT9-ALeO4_Ntt59LHz_jDnZz0O1RxJzGTign-w/viewform" rel="noreferrer" target="_blank">Formulario de inscripción</a>
          </li>
        </ul>
      </Typography>

    </div>
  );
}
